import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { getLocaleTimeFormat, getLocaleDateTimeFormat } from '@angular/common';
import { IFtpImage, updateStatus } from '../../service/type';
import ApiService from 'src/service/service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-alternateno',
  templateUrl: './alternateno.component.html',
  styleUrls: []
})
export class AlternatenoComponent implements OnInit {
  constructor(private router: Router , private ngxService: NgxUiLoaderService) { }
  alternateNo: string;
  hideall:boolean=true;
  ngOnInit() {

  }
  btnclick() {
    if (this.alternateNo) {
      const caseID = localStorage.getItem("caseID");
      const Auth = localStorage.getItem("isAuth");
      if (this.alternateNo.length === 10) {
        let data: updateStatus = {
          CaseID: caseID,
          CaseStage: "389",
          CaseStageRemark: this.alternateNo
        }
        this.ngxService.start();
        ApiService.updateStatus(data).then((responce) => {
          this.hideall=false;
          this.ngxService.stop();
          Swal.fire('success...', 'Update Successfully', 'success');
        }).catch((error) => {          
          this.ngxService.stop();
          Swal.fire('Oops...', 'Something went wrong', 'error');
        })
      }
    }
  }
}
